module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "home-page-menu-media"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 animated xFadeInLeft",
    attrs: {
      "data-id": "1"
    }
  }, [_c('div', {
    staticClass: "home-button home-media-button",
    on: {
      "click": function($event) {
        _vm.$router.push('/yt-gallery/')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "youtube",
      "scale": "6"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          VIDEO\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 animated xFadeInRight",
    attrs: {
      "data-id": "3"
    }
  }, [_c('div', {
    staticClass: "home-button home-media-button",
    on: {
      "click": function($event) {
        _vm.$router.push('/blog')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "rss",
      "scale": "6"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          BLOG\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 animated xFadeInRight",
    attrs: {
      "data-id": "3"
    }
  }, [_c('div', {
    staticClass: "home-button home-media-button"
  }, [_c('icon', {
    attrs: {
      "name": "camera-retro",
      "scale": "6"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          FOTO\n        ")], 1)])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ebce0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/MenuMedia.vue
// module id = 1195
// module chunks = 1